import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import BranchesForm from './form';
export default function BranchesCreate() {

    return (
        <div>
            <MyBreadcrumb items={[{ label: "Branches", path: "/branches" }, { label: "Create", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Create"
                subTitle=""
            >
                <BranchesForm />
            </PageHeader>
        </div>
    );
}